/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowDealbreakerFlag
 */
export interface ShadowDealbreakerFlag {
    /**
     * 
     * @type {string}
     * @memberof ShadowDealbreakerFlag
     */
    criteria_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowDealbreakerFlag
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowDealbreakerFlag
     */
    result: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowDealbreakerFlag
     */
    qualifier: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShadowDealbreakerFlag
     */
    is_medication_rule: boolean;
}

/**
 * Check if a given object implements the ShadowDealbreakerFlag interface.
 */
export function instanceOfShadowDealbreakerFlag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria_id" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "qualifier" in value;
    isInstance = isInstance && "is_medication_rule" in value;

    return isInstance;
}

export function ShadowDealbreakerFlagFromJSON(json: any): ShadowDealbreakerFlag {
    return ShadowDealbreakerFlagFromJSONTyped(json, false);
}

export function ShadowDealbreakerFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowDealbreakerFlag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria_id': json['criteria_id'],
        'query': json['query'],
        'result': json['result'],
        'qualifier': json['qualifier'],
        'is_medication_rule': json['is_medication_rule'],
    };
}

export function ShadowDealbreakerFlagToJSON(value?: ShadowDealbreakerFlag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria_id': value.criteria_id,
        'query': value.query,
        'result': value.result,
        'qualifier': value.qualifier,
        'is_medication_rule': value.is_medication_rule,
    };
}

